'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPhoneWithoutDDI = undefined;
var _wavfichacertaFichacertaUtils = require('@bit/wavfichacerta.fichacerta.utils.normalizers');
var _wavfichacertaFichacertaUtils2 = require('@bit/wavfichacerta.fichacerta.utils.validators');
var sizes = {
  generalMedium: 'col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6'
};
var defaultPhoneWithoutDDI = exports.defaultPhoneWithoutDDI = function defaultPhoneWithoutDDI(name, label) {
  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : sizes.generalMedium;
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    name: name || 'telefone_principal',
    label: label || 'WITHOUT_LABEL',
    isRequired: required,
    size: size,
    type: 'maskedText',
    validate: _wavfichacertaFichacertaUtils2.validatePhone,
    normalize: _wavfichacertaFichacertaUtils.removeNonDigit,
    placeholder: '(   ) _____-_____',
    props: {
      regex: ['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    }
  };
};